// react
import { useSelector } from 'react-redux';
// config
import { HOST_API } from '../config';
// utils
import createAvatar from '../utils/createAvatar';
// components
import Avatar from './Avatar';

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }) {
  const { user } = useSelector((state) => state.auth);

  let imgAvatar = null;
  if (user?.images_on_holuser) {
    const prependHost = (url) => /^https?:\/\//.test(url) ? url : HOST_API + url;
    imgAvatar = user.images_on_holuser.find((image) => image.location === 'PR');
    imgAvatar = imgAvatar ? { ...imgAvatar, image: prependHost(imgAvatar.image) } : null;
  }

  return (
    <Avatar alt='Avatar' color='default' src={imgAvatar?.image} {...other}>
      {createAvatar(user?.name).name}
    </Avatar>
  );
}
